import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { GStore } from "../../../context/Context";
import app from "../../../../src/Assets/AarmarBill.apk"
const Navbar = () => {
    const {english ,setEnglish} = useContext(GStore)
    // console.log(english )
  return (
    <div>
      <div className="navbar bg-base-100">
        <div className=" flex-1">
          <Link className="btn btn-ghost normal-case text-xl">{english ?"AMAR DISH  " :"আমার বিল"}</Link>
        </div>
        <div className="flex-1 justify-center">
          <ul className="flex gap-5">
            <li className="border-b shadow-md ">
              <label  className="swap ">
                <input type="checkbox" />
                <div onClick={()=>setEnglish(!english)} className=" swap-on">বাংলা</div>
                <div onClick={()=>setEnglish(!english)} className="swap-off">English</div>
              </label>
            </li>
            <li className="hidden lg:block">
              <Link className="border-b shadow-md p-4">{english ?"Dashboard" :"ডেসবোর্ড"}</Link>
            </li>
          </ul>
        </div>
        <div className="hidden lg:block">
          <button className="btn btn-primary"><a href={app}>Download Mobile app</a></button>
        </div>
        <div  className="flex-none lg:hidden">
          <label htmlFor="dashboard-drawer"  className="btn drawer-button">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              className="inline-block w-5 h-5 stroke-current"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              ></path>
            </svg>
          </label>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
